import DemoCard from '../DemoCard'
import { DemoSectionProps } from '../types'

const TimeBasedRefill = ({ triggerDemo, sendTbrItems }: DemoSectionProps ) => {
  const demos = [
    {
      demo: 'practiceMedicalWasteReset',
      isReset: true,
      buttonText: 'Reset TBR Items',
      features: [
        'Remove All Time Based Refill Data'
      ]
    },
    {
      demo: 'sendTbrItems',
      isReset: false,
      buttonText: 'Add TBR Items',
      features: [
        'BIOlogical 12',
        'BIOlogical 52',
        '1-Gallon Sharps Management',
        '1-Gallon 3 Pack Sharps Management',
        '1Qt 3Pk Sharps Management'
      ]
    }
  ]

  return (
    <DemoCard headerText='Time Based Refill' demos={demos} triggerDemo={triggerDemo} />
  )
}

export default TimeBasedRefill